module.exports = __webpack_public_path__ + "fonts/GothamSSm-BoldItalic.b5806bfc.woff2";